import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MDReactComponent from 'markdown-react-js';
import Axios from 'axios';
import moment from 'moment';

import Newsletter from '@/components/organisms/Newsletter';
import BookCta from '@/components/_common/BookCta';
import Carousel from '@/components/Carousel';
import UpcomingEvents from '@/components/organisms/UpcomingEvents';
import MetaDetail from '@/components/atoms/MetaDetail';
import HeroDate from '@/components/atoms/HeroDate';
import ButtonCTA from '@/components/atoms/ButtonCTA';
import BackBtn from '@/components/atoms/BackBtn';
import LazyLoadImage from '@/components/atoms/LazyLoadImage';
import { fetchEventsData } from '@/services/contentEvents/actions';
import getMetaScripts from './meta';

import tracking from '@/utils/tracking';

import './event.scss';

class Event extends React.Component {
	state = {
		galleryVisible: false,
		carouselGalleryRef: null
	};

	constructor(props) {
		super(props);
		this.getEvents();
	}

	async getEvents() {
		const path = window.location.pathname;
		let eventSlug = path.slice(path.lastIndexOf('/') + 1);

		if (!this.props.eventsData || !this.props.eventsData.length) {
			const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';
			await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/All Events.json?v=${Math.random()}`)
				.then(response => response.data.contents)
				.then((evts) => { this.getEventItem(evts, eventSlug); });
		}
	}

	async getEventItem(evts, slug) {
		let eventRef;

		for (let evt of evts) {
			let match = false;
			for (let field of evt.fields) {
				if (field.id === 'urlslug' && field.value === slug) {
					match = true;
					break;
				}
			}

			if (match) {
				for (let field of evt.fields) {
					if (field.id === 'event') {
						eventRef = field.value;
						await Axios.get(eventRef)
							.then((res) => {
								this.setState({ eventData: res.data.contents[0] });
								return res;
							});
					}
				}
			}
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		tracking.pageView(this.props.location.pathname);

		if (!this.props.eventsData) {
			this.props.fetchEventsData(`${this.props.apiPath}.json`);
		}
	}

	componentDidUpdate(prevProps) {
		const { pathname } = this.props.routeProps.location;

		if (prevProps.routeProps.location.pathname !== pathname) {
			window.scrollTo(0, 0);
			tracking.pageView(
				`/events/${this.props.routeProps.match.params.eventId || ''}`
			);
		}
	}

	lazyCallback() {
		if (!this.state.galleryVisible) {
			this.setState({ galleryVisible: true });
		}
	}

	formatDate(date) {
		let formattedDate = moment(date, 'DD/MM/YYYY').format('MMM Do');
		return formattedDate;
	}

	render() {
		if (!this.state.eventData) {
			return null;
		}

		let thisEvent = this.state.eventData;

		const { routeProps } = this.props;

		let title;
		let eventKey;
		let introduction;
		let bodyCopy;
		let bodyCopy2;
		let legalCopy;
		let imageCollection;
		let heroData;
		let lgHero;
		let dfltHero;
		let heroSrcSet;
		let meta;
		let startDate;
		let endDate;
		let ctaBookText;
		let ctaBookLink;
		let ctaBookAction;

		for (let field of thisEvent.fields) {
			if (field.id === 'eventtitle') {
				title = field.value;
				continue;
			}
			else if (field.id === 'urlslug') {
				eventKey = field.value;
				continue;
			}
			else if (field.id === 'introduction') {
				introduction = field.value;
				continue;
			}
			else if (field.id === 'heroimage') {
				for (let imgField of field.fields) {
					if (imgField.id === 'heroimagelarge_') {
						lgHero = imgField.imgURL;
					}
				}
				for (let imgField of field.fields) {
					if (imgField.id === 'heroimagedefault') {
						dfltHero = imgField.imgURL;
						break;
					}
				}

				heroData = lgHero || dfltHero;
				heroSrcSet = lgHero && dfltHero ? `${dfltHero} 750w, ${lgHero} 1984w` : '';
				continue;
			}
			else if (field.id === 'metainformation') {
				meta = field.fields;
				continue;
			}
			else if (field.id === 'startdate') {
				startDate = this.formatDate(field.value);
				continue;
			}
			else if (field.id === 'enddate') {
				endDate = this.formatDate(field.value);
				continue;
			}
			else if (field.id === 'bodycopy') {
				bodyCopy = field.value;
				continue;
			}
			else if (field.id === 'bodycopy2') {
				bodyCopy2 = field.value;
				continue;
			}
			else if (field.id === 'imagecollection' && field.fields.length) {
				imageCollection = field.fields.filter((imgField) => imgField.imgURL !== '');
				continue;
			}
			else if (field.id === 'legalcopy') {
				legalCopy = field.value;
				continue;
			}
			else if (field.id === 'cta-book') {
				for (let ctaField of field.fields) {
					if (ctaField.id === 'ctatext') {
						ctaBookText = ctaField.value;
						continue;
					}
					else if (ctaField.id === 'ctalink') {
						ctaBookLink = ctaField.value;
						continue;
					}
					else if (ctaField.id === 'ctaaction') {
						ctaBookAction = ctaField.value;
						continue;
					}
				}
				continue;
			}
		}

		let humanReadableDate = startDate !== endDate ? `${startDate} - ${endDate}` : `${startDate}`;

		return (
			<article className="Event">
				{/* <MetaDetail script={getMetaScripts(event)} data={meta} /> */}
				<BackBtn
					clickHandler={() => {
						tracking.event('customEvent', {
							eventCategory: 'Events Back',
							eventAction: 'click',
							eventLabel: routeProps.location.pathname
						});
						routeProps.history.goBack();
					}}
				/>
				<div className="Event__hero">
					<img
						className="Event__hero-image"
						src={heroData}
						srcSet={heroSrcSet}
						alt={title}
					/>
				</div>
				<HeroDate date={humanReadableDate} />
				<header className="Event__introduction">
					<h1 className="Event__introduction-title">{title}</h1>
					<div className="Event__introduction-copy">
						<MDReactComponent text={introduction} />
					</div>
				</header>
				<div className="container-fluid">
					<div className="row">
						<div className="Event__description">
							<div className="Event__description-intro">
								<MDReactComponent text={bodyCopy} />
							</div>
							<div className="Event__description-main">
								<MDReactComponent text={bodyCopy2} />
							</div>

							<div className="Event__cta">
								{legalCopy && (
									<div className="Event__cta-legalcopy">
										<MDReactComponent text={legalCopy} />
									</div>
								)}
								{ctaBookText && ctaBookLink && (
									<ButtonCTA
										href={ctaBookLink}
										label={ctaBookText}
									/>
								)}
							</div>
						</div>
					</div>
				</div>

				{imageCollection.length ? (
					<div
						className="Event__carousel-wrapper"
						key={`events-carousel_${eventKey}`}
						style={this.state.galleryVisible ? { opacity: 1 } : { opacity: 0 }}
						ref={el => {
							if (!this.state.carouselGalleryRef && el) {
								this.setState({ carouselGalleryRef: el });
							}
						}}
					>
						<Carousel
							desktopEnabled
							className="Event__carousel"
							arrows
							settings={{ responsive: { 578: { items: 2 } } }}
							slidesToShow={2}
						>
							{imageCollection.map((item, index) => (
								<LazyLoadImage
									key={`events-carousel-item_${index}`}
									className="Event__carousel-image"
									src={item.imgURL}
									alt={item.alternatetext}
									lazyCallback={() => this.lazyCallback()}
								/>
							))}
						</Carousel>
					</div>
				) : (
					''
				)}

				<UpcomingEvents
					filter={eventKey}
					dataKey="Data__Events"
					routeProps={this.props.routeProps}
					key={eventKey}
				/>

				<Newsletter
					formData={this.props.componentData.signUpForm}
					fetchData={this.props.fetchData}
					routeProps={this.props.routeProps}
				/>
				{ctaBookLink && (
					<BookCta
						link={ctaBookLink}
						label={ctaBookText}
						routeProps={this.props.location.pathname}
					/>
				)}
			</article>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	eventsData: state.pageContent.eventsData[ownProps.apiPath]
});

export default withRouter(
	connect(
		mapStateToProps,
		{ fetchEventsData }
	)(Event)
);



// WEBPACK FOOTER //
// ./src/components/organisms/Event/index.js